import React from 'react';
import PropTypes from 'prop-types';
//import classNames from 'classnames';
//import {sizes} from 'epic-diesel-common/src/constants';
//import {Icon} from 'epic-diesel-common';
import Message, {getMessage} from '../../common/Message';
//import glyphStyles from '../../../glyphs';
import styles from './SettingsLink.pcss';

// const socialNetworkIcons = {
//     facebook: glyphStyles.facebook,
//     google: glyphStyles.google,
//     twitch: glyphStyles.twitch,
//     none: glyphStyles.epic
// };

export default class SettingsLink extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        sectionData: PropTypes.array,
        //trigger: PropTypes.func,
        value: PropTypes.string
        //accountManagementUrl: PropTypes.string
    };

    render() {
        const {
            value,
            sectionData,
            messages
            //     trigger,
            //     accountManagementUrl
        } = this.props;
        //const socialLinkUrl = `${accountManagementUrl}/connected`;
        const currentLink = sectionData.find(item => item.slug === value) || {};

        //const linkDescription = getMessage(messages, 'epic.affiliate.settings.link_description', [socialLinkUrl, currentLink ? currentLink.link : '']);

        const creatorLink = getMessage(messages, 'epic.affiliate.settings.link_body', ['https://epicgames.helpshift.com/a/epic-accounts/?s=epic-account-support']);

        return (
            <div className={styles.section}>
                <div className={styles.title}>
                    <Message code="epic.affiliate.settings.link_title" />
                </div>
                <div>
                    <div dangerouslySetInnerHTML={{__html: creatorLink}} />
                </div>
                <div className={styles.link} key={currentLink.slug}>
                    <span className={styles.linkId}>{currentLink.slug}</span>
                </div>
                {/* <div className={styles.desc}>
                    <span dangerouslySetInnerHTML={{__html: linkDescription}} />
                </div>
                {sectionData.map((item, key) => {
                    const checked = value === item.slug;
                    const cls = classNames(styles.link, {
                        [styles.empty]: !checked
                    });
                    return (
                        <div
                            className={cls}
                            key={item.slug}
                            onClick={() => trigger('slug', item.slug)}>
                            <Icon icon={checked ? glyphStyles.circle : glyphStyles.circleEmpty} size={sizes.XSMALL} />
                            <Icon icon={socialNetworkIcons[item.externalAuthIdType]} size={sizes.MEDIUM} />
                            <span className={styles.linkId}>{item.slug}</span>
                        </div>
                    );
                })} */}
            </div>
        );
    }
}
